import { Box } from '@mui/material'
import React from 'react'
import { Col, Container, NavLink, Row } from 'react-bootstrap'
import "./groupfares-link.css"
import groupfares from '../../assets/images/groupfares.png'
import link from '../../assets/images/groupfare-icon.gif'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function GroupfaresLink() {
    return (
        <Container>
            <Box className='px-4'>
                <Row className='portal-link-container'>
                    <img className='link-img' src={link} />
                    <Col xs={12} md={10} className='px-0'>
                        <Box className='portal-link'>
                            <Box className='portal-link-logo'>
                                <img src={groupfares} />
                            </Box>
                            <p className='portal-link-p'>Avail air tickets and other travel related amenities at best deals if you’re a group of 2 or more traveling to the same destination.</p> 
                        </Box>
                    </Col>
                    <Col xs={12} md={2}>
                        <Box className='portal-link-btn'><NavLink href="https://www.groupfares.in/" target="_blank">Explore Now <ArrowForwardIcon /></NavLink></Box>
                    </Col>
                </Row>
            </Box>
        </Container>
    )
}

export default GroupfaresLink
